<h1 mat-dialog-title>{{ 'Mutations.Title' | translate }}</h1>
<div mat-dialog-content>
    <igx-hierarchical-grid [data]="mutations" width="100%" height="400px" primaryKey="id" [autoGenerate]="false" #grid>
        <igx-column field="createdTime" header="{{ 'Mutations.Date' | translate }}" dataType="date" [sortable]="true" [resizable]="true">
            <ng-template igxCell let-cell="cell">
                {{ cell.value | localizedDate: 'short' }}
            </ng-template>
        </igx-column>
        <igx-column
            field="createdByUser"
            header="{{ 'Mutations.User' | translate }}"
            dataType="string"
            [sortable]="true"
            [resizable]="true" />
        <igx-row-island primaryKey="id" [autoGenerate]="false" (gridCreated)="loadChildren($event)" width="100%">
            <igx-column field="fieldName" header="{{ 'Mutations.FieldName' | translate }}" />
            <igx-column field="oldValue" header="{{ 'Mutations.OldValue' | translate }}" />
            <igx-column field="newValue" header="{{ 'Mutations.NewValue' | translate }}" />
        </igx-row-island>
    </igx-hierarchical-grid>
</div>
<div mat-dialog-actions [align]="'end'">
    <button mat-button (click)="close()" cdkFocusInitial>OK</button>
</div>
